import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import BlueNormalButton from "../customButtons/BlueNormalButton";
import PrimarySmallBlueButton from "../customButtons/PrimarySmallBlueButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function NoDataAvailabWithNoCardleScreen({
  text,
  subText,
  maxWidth,
  buttonName,
  topImage,
  redirectionLink,
  buttonIcon,
  showTopImage = true,
  imageSize
}) {
  

  return (
    <Box
      sx={{
        maxWidth: maxWidth ? maxWidth : 800,
        mx: "auto",

        // p: 8,
        px: { xs: 2, sm: 7, md: 15 },
        textAlign: "center",
        borderRadius: 4,
        backgroundColor: "#fff",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        position: "relative",
      }}
    >
      <Grid container spacing={1}>
        {showTopImage && (
          <Grid item xs={12}>
            <Box
              sx={{
                width: imageSize ? imageSize : 180,
                height:imageSize ? imageSize : 180,
                mx: "auto",
              }}
            >
              {topImage}
            </Box>
          </Grid>
        )}

        {/* Title */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="22px"
            color="#343538"
            sx={{
              fontWeight: 600,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: "1.4",
            }}
          >
            {text}
          </Typography>
        </Grid>

        {/* Subtitle */}
        <Grid item xs={12}>
          {" "}
          <Typography
            fontSize="16px"
            color="#3F424C"
            sx={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontStyle: "normal",
              letterSpacing: "0px",
              verticalAlign: "middle",
              lineHeight: 1.5,
            }}
          >
            {subText}
          </Typography>
        </Grid>

        {/* Button */}
        <Grid item xs={12} mt={1}>
          {" "}
          <PrimarySmallBlueButton
            buttonTitle={buttonName}
            endIcon={buttonIcon ? buttonIcon : <ArrowForwardIcon />}
            onClick={redirectionLink}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
